'use client';

import React, {Suspense} from "react";
import SubscribePage from "@/components/SubscribePage";


const Subscribe = ({ gtag }) => {

    return (
        <Suspense fallback={<div>Loading...</div>}>
            <SubscribePage />
        </Suspense>);
}
export default Subscribe;